<template>
  <div class="colorFondo margen" v-if="!mostrar">

    <v-snackbar v-model="snackbar" :timeout="20000" :color="colorSnack">
      <div class="d-flex justify-space-around">
        <span class="ma-2"> {{ mensajeSnackbar }} </span>
        <v-btn text dark @click="snackbar = !snackbar"> Cerrar </v-btn>
      </div>
    </v-snackbar>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <v-row class="pb-3 d-flex justify-space-around">
        <v-col cols="12" sm="12" md="3" class="ma-auto">
          <h1>Proyectos</h1>
        </v-col>
        <v-col cols="12" sm="12" md="3" class="ma-auto mb-n6">
          <v-checkbox v-model="mostrarTodosProyectos" label="Mostrar todos los proyectos" class="mb-2" hide-details="" dense></v-checkbox>
          <v-text-field dense outlined label="Buscar Proyecto" v-model="buscarProyecto" class="mx-2"/>
        </v-col>
        <v-col cols="12" sm="12" md="3" class="ma-auto">
          <v-btn class="mt-2 success" @click="mostrar=!mostrar">Nuevo Proyecto</v-btn>
        </v-col>
      </v-row>
    </v-container>

    <div v-if="cargando" style="width:100%!important; height:100%!important; display:grid; place-items:center;" class="mt-5">
      <div style="">
        <v-alert class="blue accent-4 d-flex justify-center">
          <span class="white--text">Cargando...</span>
        </v-alert>
      </div>
    </div>

    <v-row no-gutters class="d-flex justify-space-around" v-if="proyectos.length > 0">
      <v-col cols="12" xs="12" sm="6" md="3" class="mt-3 mx-1" v-for="proyecto in filtrarProyectos" :key="proyecto.PROYECTO_ID">
        <v-card class="px-1">
          <v-card-title class="d-flex justify-center text-h4 font-weight-medium" id="titulo-card"> {{proyecto.FOLIO}} </v-card-title>
          
            <div class="d-flex justify-space-around">
                <v-card-title> Cliente </v-card-title> 
                <v-card-title class="text-body-1 paddingTextoCarta overflow" >
                  <p :title="proyecto.NOMBRE"> 
                    <!-- {{ cortarString( proyecto.NOMBRE, 19) }}  -->
                    {{proyecto.NOMBRE}}
                  </p>
                </v-card-title>
            </div>
            <!-- <div class="d-flex justify-space-around">
                <v-card-title> Folio </v-card-title> <v-card-title class="text-body-1">{{proyecto.FOLIO}}</v-card-title>
            </div> -->

            <v-spacer class="my-1"></v-spacer>
            <div class="d-flex">
            <v-card-title class=" mx-auto subtitle-4 d-flex justify-start">Progreso</v-card-title>
            <v-progress-linear class="mr-2 my-auto" :value="proyecto.progreso" rounded height="25">
              <strong v-if="proyecto.progreso > 45" class="white--text"> {{ Math.ceil(proyecto.progreso) }} % </strong>
              <strong v-else> {{ Math.ceil(proyecto.progreso) }} % </strong>
            </v-progress-linear>
            </div>

            <div class="d-flex">
            <v-card-title style="width:50%;" class="pa-0 px-4 mx-auto subtitle-4 d-flex justify-start">Compras</v-card-title>
            <v-progress-linear style="width:50%;" class="mr-2 my-auto" :value="proyecto.progresoCOMPRA" color="green darken-4" rounded height="25">
              <strong v-if="proyecto.progresoCOMPRA > 45" class="white--text"> {{ Math.ceil(proyecto.progresoCOMPRA) }} % </strong>
              <strong v-else> {{ Math.ceil(proyecto.progresoCOMPRA) }} % </strong>
            </v-progress-linear>
            </div>
 
            <div class="d-flex">
            <v-card-title style="width:50%;" class="pa-0 px-4 mx-auto subtitle-4 d-flex justify-start">Almacen</v-card-title>
            <v-progress-linear style="width:50%;" class="mr-2 my-auto" :value="proyecto.progresoALMACEN" color="deep-orange darken-4" rounded height="25">
              <strong v-if="proyecto.progresoALMACEN > 45" class="white--text"> {{ Math.ceil(proyecto.progresoALMACEN) }} % </strong>
              <strong v-else> {{ Math.ceil(proyecto.progresoALMACEN) }} % </strong>
            </v-progress-linear>
            </div>
 
            <div class="d-flex">
            <v-card-title style="width:50%;" class="pa-0 px-4 mx-auto subtitle-4 d-flex justify-start">Taller</v-card-title>
            <v-progress-linear style="width:50%;" class="mr-2 my-auto" :value="proyecto.progresoTALLER" color="orange darken-4" rounded height="25">
              <strong v-if="proyecto.progresoTALLER > 45" class="white--text"> {{ Math.ceil(proyecto.progresoTALLER) }} % </strong>
              <strong v-else> {{ Math.ceil(proyecto.progresoTALLER) }} % </strong>
            </v-progress-linear>
            </div>
 
            <div class="d-flex justify-space-around">
                <v-card-title>Estatus</v-card-title> <v-card-title class="text-body-1"> {{mostrarEstatus(proyecto)}}</v-card-title>
            </div>

            <div class="d-flex justify-center" v-if="getRolesUsuario.includes('SA')">
                <v-card-text class="pa-0" style="text-align:center; font-size:1rem;">Creado por {{proyecto.USUARIO_CREADOR}}</v-card-text>
            </div>

            <OpcionesProyecto
            :infoProyecto="proyecto"
            @snackbar="mostrarSnackbar"
            @ActualizarProyectos="ActualizarProyectos"/>

        </v-card>
      </v-col>

      
    </v-row>
    <div v-else-if="!cargando" style="width:100%!important; height:100%!important; display:grid; place-items:center;" class="mt-5">
      <div style="">
        <v-alert class="orange accent-4 d-flex justify-center">
          <span class="white--text">No se encontraron proyectos asignados...</span>
        </v-alert>
      </div>
    </div>
  </div>
  <div v-else>
    <CrearProyecto 
    @mostrar='mostrar=!mostrar'
    @ActualizarProyectos="ActualizarProyectos"/>
  </div>
</template>

<script>
import CrearProyecto from './CrearProyecto.vue'
import OpcionesProyecto from './OpcionesProyecto.vue'
import axios from 'axios'
import { mapGetters } from 'vuex';


export default {
  components: {OpcionesProyecto , CrearProyecto},

  data() {
    return {
        proyectos:[],
        progreso: 51, // Asignar mediante metodo y en el metodo dividir entre el total de tareas.
        mostrar: false,

        snackbar:false,
        mensajeSnackbar:'',
        colorSnack:'',

        cargando:false,

        buscarProyecto:'',
        mostrarTodosProyectos:false,
    };
    
  }, 
  computed: {
    ...mapGetters(['getURLAPI','getRolesUsuario','getUsuarioID']),

    // BUSQUEDA DE PROYECTOS
    filtrarProyectos: function (){
      return this.proyectos.filter( (proyecto) => {
        return    proyecto.FOLIO.  toLowerCase().match( this.buscarProyecto.toLowerCase() ) 
               || proyecto.NOMBRE. toLowerCase().match( this.buscarProyecto.toLowerCase() )
               || proyecto.USUARIO_CREADOR. toLowerCase().match( this.buscarProyecto.toLowerCase() )
               || this.mostrarEstatus(proyecto).toLowerCase().match( this.buscarProyecto.toLowerCase() )
               
      })
    },
  },

  watch: {
    mostrarTodosProyectos(){
      this.ActualizarProyectos();
    }  
  },


  methods: {
    // ------------------------------------------------------------------------------
    cortarString(string, tamaño) {
      return string.length > tamaño
        ? string.substring(0, tamaño) + "..."
        : string;
    },

    // ------------------------------------------------------------------------------
    mostrarEstatus(item){
      let estatus = "" ;
      switch( item.ESTATUS ){
        case 'P':
          estatus = "PENDIENTE";
          break;
        case 'C':
          estatus = "COMPRA";
          break;
        case 'D':
          estatus = "EN ALMACEN";
          break;
        case 'A':
          estatus = "EN TALLER";
          break;
        case 'T':
          estatus = "TERMINADO";
          break;
        case 'B':
          estatus = "CANCELADO";
          break;
        default:
          estatus = "No definido"
          break;
      }
      return estatus;
    },

    // ------------------------------------------------------------------------------
    calcularProgreso(item){
      switch( item.ESTATUS ){
        case 'P':
          item.progreso = 0;
          break;
        case 'C':
          item.progreso = 25;
          break;
        case 'D':
          item.progreso = 50;
          break;
        case 'A':
          item.progreso = 75;
          break;
        case 'T':
          item.progreso = 100;
          break;
        case 'B':
          item.progreso = 0;
          break;
        default:
          item.progreso = 0;
          break;
      }
    },

    // ------------------------------------------------------------------------------
    calcularProgresoCompras( item ){
      if (item.DATOSCOMPRA != null) {
        let progreso = item.DATOSCOMPRA.split("|");
        item.progresoCOMPRA = (progreso[0] / progreso[1]) * 100;
        
      }else{
        item.progresoCOMPRA = 0;
      }
    },

    // ------------------------------------------------------------------------------
    calcularProgresoAlmacen( item ){
      if (item.DATOSALMACEN != null) {
        let progreso = item.DATOSALMACEN.split("|");
        console.log(progreso);
        item.progresoALMACEN = (progreso[0] / progreso[1]) * 100;
        console.log(item.progresoALMACEN);
        
      }else{
        item.progresoALMACEN = 0;
      }
    },

    // ------------------------------------------------------------------------------
    calcularProgresoTaller( item ){
      console.log("taller", item.DATOSTALLER);
      if (item.DATOSTALLER != null && item.DATOSTALLER.split("|")[0] != 0 ) {
        let progreso = item.DATOSTALLER.split("|");
        console.log("taller",progreso);
        item.progresoTALLER = (progreso[0] / progreso[1]) * 100;
        console.log("TALLER",item.progresoTALLER);
        
      }else{
        item.progresoTALLER = 0;
      }
    },

    // ------------------------------------------------------------------------------
    async ActualizarProyectos(){

      this.proyectos =[];
      this.cargando = true;

      if (this.getRolesUsuario.includes("SA") || this.getRolesUsuario.includes("ADMIN")) {
        let datosForm = new FormData();
        datosForm.append("MOSTRAR_TODOS", this.mostrarTodosProyectos);
        
        this.proyectos = (await axios.post(`${this.getURLAPI}/show/allProyect`, datosForm)).data
      }
      else{
        let datosForm = new FormData();
        datosForm.append("USUARIO_ID", this.getUsuarioID);
        datosForm.append("MOSTRAR_TODOS", this.mostrarTodosProyectos);

        this.proyectos = (await axios.post(`${this.getURLAPI}/show/allProyectUsuario`,datosForm)).data
      }
      this.proyectos.forEach( proyecto => {
        this.calcularProgreso( proyecto );
        this.calcularProgresoCompras ( proyecto );
        this.calcularProgresoAlmacen ( proyecto );
        this.calcularProgresoTaller ( proyecto );
      });
      this.cargando = false;
      // console.log(this.proyectos);
      // this.proyectos = (await axios.get(`${this.getURLAPI}/Proyectos/all`)).data
    },

    // ------------------------------------------------------------------------------
    mostrarSnackbar ( datos ){
      this.snackbar = true;
      // console.log("datos: " + datos);
      this.mensajeSnackbar = datos.MSG;
    }
  },
  created() {
    document.title = "Proyectos | Bombas y Suministros del Norte";
    this.ActualizarProyectos();
    // console.log( "ROL", this.getRolesUsuario.includes("SA") );

    // agregar async a created
    // this.proyectos = (await axios.get(`${this.getURLAPI}/url`)).data
    
  },
};
</script>

<style scoped>
.colorFondo{
  background-color: #d1d1d1!important;
}

.v-card__title{
  word-break: inherit !important;
}

.paddingTextoCarta{
  padding-left: auto!important;
}

p{
  margin-bottom: 0!important;
}

.overflow{
  overflow: hidden;
  max-height: 65px;
}
.overflow:hover{
  max-height: inherit!important;
  overflow: visible;
}

#titulo-card{
  overflow: hidden!important;
  /* overflow-wrap: break-word; */
  hyphens: auto!important;
  word-break: normal !important;
}

#titulo-card:hover{
  overflow: hidden!important;
  overflow-wrap: break-word;
  hyphens: auto!important;
  word-break: break-word !important;
}
</style>
